module.exports = __webpack_public_path__ + "img/act-基本设置.7a8f5e85.png";